import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import styles from "./CardContainer.module.scss";
export const CardContainer = forwardRef(({ variant = "variant1", pending = false, className, children, ...rest }, ref) => (_jsx("div", { ...rest, "data-variant": `card-${variant}`, className: classNames(styles.container, styles[`variant-${variant}`], className, { [styles.pending]: pending }), ref: ref, children: children })));
//# sourceMappingURL=CardContainer.js.map